<template>
  <f7-panel left :opened="isLaptop" style="box-shadow: 3px 0px 3px silver;" :close='loggingout'>
    <f7-view id="left-panel-view" navbar-through :dynamic-navbar="true" :style="'border-right : ' + '2px solid ' + color + ';'">
      <f7-navbar class="leftPanelNavBar">
        <div class="leftPanelTopBlock">
          <!-- Classe boxRequest à remettre après la démo GCollect -->
          <div class="milkyBlock" :class="{boxRequest : $engine.user.validateAccess('changeProfile')}" style="vertical-align:baseline;" @click="activateModalProfile">
            <img class="navbarProfileImage" style="" src="./../../assets/static/images/image-profile.png"></img>
            <p style="display:inline-block;margin:auto">
              <span class="leftPanelNameLabel" style="display:inline-block;vertical-align: baseline;">{{accountName}}</span>
              <!-- TLV 21/08/2020 : On cache le chevron pour la livraison GCollect -->
              <f7-icon f7="chevron_down" v-if="$engine.user.validateAccess('changeProfile')" style="display:inline-block;vertical-align:middle;margin: auto;" color="black" size="16"></f7-icon>
            </p>
            <p class="leftPanelLoginLabel" v-if="type === '1'" style="margin-left:33px;padding-left:15px">{{ $t('businessMembers.mmbr') }} : {{accountLogin}}</p>
          </div>
          <div class="leftPanelApplicationLabel" v-bind:style="{'background-color':color}">{{ $t('common.appname') }} - {{ serviceLabel }}</div>
        </div>
      </f7-navbar>
      <f7-pages>
        <f7-page class="menuPage">
          <services-menu :type="type" :serviceName="serviceName"></services-menu>
        </f7-page>
      </f7-pages>
    </f7-view>
  </f7-panel>
</template>

<script>
import servicesMenu from '@/components/leftPanel/servicesMenu.vue'

export default {
  name: 'LeftPanel',
  components: {
    'services-menu': servicesMenu
  },
  data: () => {
    return {
      serviceName: '',
      serviceLabel: '',
      type: 0,
      accountName: '',
      accountLogin: '',
      color: '',
      loggingout: false,
      windowWidth: window.innerWidth
    }
  },
  created: function () {
    let that = this
    /* A chaque changement de type d'utilisateur ou de service, le menu de gauche
        est mis à jour avec les données de son fichier .json correspondant */
    this.$bus.$on('refresh-cache-menu', () => {
      if (that.$engine.user.get().id !== -1) {
        that.type = that.$engine.user.get().type
        this.accountName = that.$engine.user.get().name
        let userId = that.$engine.user.get().userAccountId
        let userLogin = that.$engine.accounts.get()[0].userAccts.filter(user => user.id === userId)[0].login
        that.accountLogin = that.$engine.accounts.get().filter(user => user.identifier === userLogin)[0].name
      }
    })
    this.$bus.on('service:change', (val) => {
      that.serviceName = val
      if (that.serviceName) {
        that.color = that.$engine.services.getServiceByName(val).color
        let nameLabel = that.$engine.services.getServiceByName(val).name
        that.serviceLabel = this.$i18n.t(nameLabel)
      }
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    this.loggingout = true
  },
  methods: {
    activateModalProfile () {
      // TLV 26/08/2020 : changement de profil seulement pour les utilisateurs autorisés
      if (this.$engine.user.validateAccess('changeProfile')) {
        this.$f7.popup('#switch-profile-true')
      }
    },
    getServiceColor (service) {
      return this.$engine.services.getServiceColor(this.$engine.user.currentService.id)
    },
    handleResize () {
      let that = this
      that.windowWidth = window.innerWidth
      that.$engine.services.directPayments.filter.smartphoneStorage = !that.isLaptop
      that.$bus.emit('window-resize')
    }
  },
  computed: {
    isLaptop () {
      return this.windowWidth > 992
    }
  }
}
</script>
<style>

.enablePanel
{
  display: block !important;
  -webkit-transform: translate3d(0,0,0) !important;
  transform: translate3d(0,0,0) !important;
}

.disablePanel
{
  display: none !important;
}

.leftPanelLoginLabel {
  margin: 2.5px 0px 0px 10px;
  font-size: 14px;
  color: black;
}

.leftPanelNameLabel {
  margin: 2.5px 0px 0px 10px;
  font-size: 14px;
  font-weight: bold;
  color: black;
}

.iconColor {
  color: #3870af;
}

.menu-label {
  color: #000; /* #144a85 */
  width: 80%;
}

.leftPanelNavBar {
  position: relative;
  color: #ffffff;
  height: 123px;
  background-image: url('../../assets/static/images/MenuFont.png')
}
.leftPanelNavBar>.navbar-inner {
  padding: 0px !important;
}
.menuPage {
  background-color: #ffffff;
  padding-top: 85px !important;
}

#logoutButton {
  position: absolute;
  right: 5px;
}
.blockServiceName {
  background-color:#12bcf1;
  color:white;
  font-size: 14px;
  padding:5px 0px 2px 0px;
  text-align:center;
}
.leftPanelTopBlock {
  height:100%;
  width:100%;
}
.leftPanelProfileImageBlock {
  margin:10px 0px 0px 10px;
}
.leftPanelApplicationLabel {
  position:absolute;
  bottom:0px;
  width:100%;
  text-align:center;
  /* background-color:#12bcf1; */
  color:white;
  padding:3px 0px;
  font-size:14px;
}

.page-content {
  overflow-x: hidden;
}

.milkyBlock {
  background-color: rgba(255, 255, 255, 0.7);
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  padding: 10px;
  border-radius: 10px;
  border : 1px lightgrey solid;
  box-shadow: 2px 2px 3px 1px silver;
}
</style>



// WEBPACK FOOTER //
// CMLeftPanel.vue?2bee2aa6